class MainArticleTemplate extends HTMLElement{
  constructor(){
    super();
    this.selectors= {
      a: '[link-item]'
    }
    this.init();
  }

  init() {
    this.querySelectorAll(this.selectors.a).forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');
        if (href && href.startsWith('#')) {
          e.preventDefault();
          const target = this.querySelector(`[data-id="${href.substring(1)}"]`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }
      });
    });
  }
}
customElements.define('main-article-template', MainArticleTemplate);